import { render, staticRenderFns } from "./AppAnexo.vue?vue&type=template&id=5e10c2a2&scoped=true&lang=pug&"
import script from "./AppAnexo.vue?vue&type=script&lang=js&"
export * from "./AppAnexo.vue?vue&type=script&lang=js&"
import style0 from "./AppAnexo.vue?vue&type=style&index=0&id=5e10c2a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e10c2a2",
  null
  
)

export default component.exports